import { newRequest, oldRequest } from "./complexRequest"
import { ComplexRequestOption, PageQueryFn, PageResponse, ResponseType, RobotData, SupportLangsTypeList, UserDetail } from "./type"

// 个人详情
export const getProfileDetail = async (
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<ResponseType<UserDetail>>({
    url: '/Api/User/detail',
    ...option
  }, useFetch)
}

// 获取关注数量
export const getFollowerDetail = async (
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<ResponseType<{
    follower_count: number
    attention_count: number
    block_count: number
    robot_comment_count: number
    collect_count: number
  }>>({
    url: '/Api/Follower/count',
    ...option
  }, useFetch)
}


// 修改个人信息author_note
export const updateProfileNote = async (
  data: {
    author_note: string,
    user_id: number

  },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<ResponseType<any>>({
    url: '/Api/Follower/author_note',
    data,
    ...option
  }, useFetch)
}

// 更新用户信息
export const updateProfile = async (
  data: {
    name?: string
    gender?: number
    user_id: number
    avatar?: string
    lang_code?: SupportLangsTypeList
  },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<ResponseType<any>>({
    url: '/Api/User/update',
    data,
    ...option
  }, useFetch)
}


// 密码检测
export const checkOldPassword = async (
  data: {
    password: string,
  },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<ResponseType<any>>({
    url: '/Api/Passport/checkOldPassword',
    data,
    ...option
  }, useFetch)
}


// 修改密码
export const updatePassword = async (
  data: {
    password: string,
    token: string, // 验证密码token
    confirm_password: string
  },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<ResponseType<any>>({
    url: '/Api/Passport/updatePassword',
    data,
    ...option
  }, useFetch)
}


// 设置用户年龄/性别（对齐 APP 端 client/user/update）
// age 为档位索引: 0:<14 1:14-17 2:18-20 3:21-23 4:24-26 5:26+
export const updateUserAgeGender = async (
  data: {
    age?: number
    gender?: number
    force?: boolean
  },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return newRequest<ResponseType<{ age?: number, gender?: number }>>({
    url: '/client/user/update',
    data,
    method: 'post',
    ...option
  }, useFetch)
}

// 更新nsfw
export const updateNsfw = async (
  data: {
    status: 1 | 0
  },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return newRequest<ResponseType<any>>({
    url: '/client/user/update-nsfw',
    data,
    method: 'post',
    ...option
  }, useFetch)
}

export const vipExpired = async (
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return newRequest<ResponseType<any>>({
    url: '/client/user/vip-expired',
    method: 'get',
    ...option
  }, useFetch)
}

// 获取用户余额（能量 / 星币）
export const getCoinBalance = async (
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return newRequest<ResponseType<{ energy_coin?: number; coin?: number; start_coin?: number }>>({
    url: '/client/user/coin-balance',
    method: 'get',
    ...option
  }, useFetch)
}

// 打赏创作者（消耗水晶）
export const tipCreator = async (
  data: {
    to_user_id: number
    amount: number
    user_id: number
  },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return newRequest<ResponseType<{ star_coin?: number; tip_count?: number }>>({
    url: '/api/go/user/crystal/tip',
    data,
    method: 'post',
    ...option
  }, useFetch)
}


// 更新个人配置
export const updatePersonalConfig = async (
  data: {
    is_show_fans?: 1 | 0
    is_show_follows?: 1 | 0
    is_chat_stream?: 1 | 0
    is_robot_translation?: 1 | 0
  },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return newRequest<ResponseType<any>>({
    url: '/client/user/set-config',
    data,
    method: 'post',
    ...option
  }, useFetch)
}

// 获取用户机器人
export const getUserRobot: PageQueryFn = async (
  data: {
    category_id?: number
    is_use?: boolean
    report_status?: 30
    audit_status?: 10 | 20
  },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<PageResponse<RobotData>>({
    url: '/Api/v1.0/Robots/userRobots',
    data,
    ...option
  }, useFetch)
}

// 获取用户人设
export const getUserPersona: PageQueryFn = async (
  data,
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<PageResponse<RobotData>>({
    url: '/Api/UserCharacter/index',
    data,
    ...option
  }, useFetch)
}

export type UserInfo = {
  is_hiwaifu: number,
  username: string,
  user_id: number,
  avatar: string,
  author_note: string,
  follow_num: number,
  fans_num: number,
  is_follow: boolean,
  block_state: boolean,
  is_show_follows: number,
  is_show_fans: number
  name: string
  vip: boolean
  /** 该用户累计收到的打赏次数 */
  tip_count?: number
}
// 获取其他用户的信息
export const getUserInfoById = async (
  data: { find_user_id: string },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<ResponseType<UserInfo>>({
    url: '/Api/Follower/userInformation',
    data,
    ...option
  }, useFetch)
}


// 获取其他用户的机器人
export const getOtherUserRobots: PageQueryFn<{ find_user_id: string }> = async (
  data,
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<PageResponse<RobotData>>({
    url: '/Api/v1.0/Robots/otherUserRobots',
    data,
    ...option
  }, useFetch)
}

// 获取用户创建的机器人类型
export const getUserRobotCategories = async (
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return newRequest<ResponseType<any>>({
    url: '/client/user/robot-categories',
    method: 'get',
    ...option
  }, useFetch)
}

// 关注
export const followById = async (
  data: { follower_user_id: string },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<ResponseType>({
    url: '/Api/Follower/follower',
    data,
    ...option
  }, useFetch)
}

// 取消
export const unfollowById = async (
  data: { follower_user_id: string },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<ResponseType>({
    url: '/Api/Follower/cancelFollower',
    data,
    ...option
  }, useFetch)
}

// 拉黑
export const blockById = async (
  data: { user_id: number },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return newRequest<ResponseType>({
    url: '/client/user/block',
    data,
    method: 'post',
    ...option
  }, useFetch)
}

// 取消拉黑
export const unblockById = async (
  data: { user_id: number },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return newRequest<ResponseType>({
    url: '/client/user/unblock',
    data,
    method: 'post',
    ...option
  }, useFetch)
}

// 通过code获取用户信息
export const getUserInfoByCode = async (
  data: { code: string },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<ResponseType>({
    url: '/Api/User/getInfoByCode',
    data,
    ...option
  }, useFetch)
}

// 获取拉黑列表(profile)
export const getBlockList: PageQueryFn = async (
  params,
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return newRequest<PageResponse<RobotData>>({
    url: '/client/user/blocklist',
    params,
    method: 'get',
    ...option
  }, useFetch)
}

// 获取评论列表
export const getCommentList: PageQueryFn = async (
  params,
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return newRequest<PageResponse<RobotData>>({
    url: '/client/robot/user-comments',
    params,
    method: 'get',
    ...option
  }, useFetch)
}


// 删除评论
export const deleteComment = async (
  params,
  option: ComplexRequestOption = {},
  useFetch = true) => {
  return newRequest<PageResponse<RobotData>>({
    url: '/client/robot/comment-delete',
    params,
    method: 'delete',
    ...option
  }, useFetch)
}

// 获取收藏机器人列表
export const getCollectionRobot: PageQueryFn = async (
  params,
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return newRequest<PageResponse<RobotData>>({
    url: '/client/robot/collects',
    params,
    method: 'get',
    ...option
  }, useFetch)
}

// 收藏的机器人接口
export const deleteCollectionRobot = async (
  params: { robot_id: number },
  option: ComplexRequestOption = {},
  useFetch = true) => {
  return newRequest<PageResponse<RobotData>>({
    url: '/client/robot/collect',
    params,
    method: 'get',
    ...option
  }, useFetch)
}

// 获取收藏机器人分类列表
export const getCollectionRobotCategories: PageQueryFn = async (
  params,
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return newRequest<PageResponse<RobotData>>({
    url: '/client/robot/collect-categories',
    params,
    method: 'get',
    ...option
  }, useFetch)
}

// 获取关注列表
export const getFollowingList: PageQueryFn<{ find_user_id?: string }> = async (
  data,
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<PageResponse<any>>({
    url: '/Api/Follower/followers',
    data,
    ...option
  }, useFetch)
}



// 获取追随者列表
export const getFollowerList: PageQueryFn<{ find_user_id?: string }> = async (
  data,
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<PageResponse<any>>({
    url: '/Api/Follower/attentions',
    data,
    ...option
  }, useFetch)
}

// 举报用户
export const reportUser = async (
  data: {
    reson_text: string, reson: number,
    robots_id: number, // 用户id
    type: number
  },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<ResponseType>({
    url: '/Api/Robots/report',
    data,
    method: 'post',
    ...option
  }, useFetch)
}

// 更新机器人的DefinitionVisibility
export const updateDefinitionVisibility = async (
  data: { user_id: number, robot_id: number, definition_visibility: 0 | 1 },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<ResponseType>({
    url: '/Api/v1.0/Robots/definitionVisibility',
    data,
    method: 'post',
    ...option
  }, useFetch)
}


// 删除账户
export const deleteAccount = async (
  data: { user_id: number },
  option: ComplexRequestOption = {},
  useFetch = true) => {

  return oldRequest<ResponseType>({
    url: '/Api/User/delete',
    data,
    method: 'post',
    ...option
  }, useFetch)
}